import { getLocales } from 'assets/locales/Locale';
import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';
import Model from 'models/Model';

export async function productEnhancementTierPricePointListApi(
  body: Api.Core.ProductEnhancementTierPricePoint.List.IRequest
): Promise<Api.Res<Api.Core.ProductEnhancementTierPricePoint.List.IResponse>> {
  return await executeServerApi<
    Api.Core.ProductEnhancementTierPricePoint.List.IRequest,
    Api.Core.ProductEnhancementTierPricePoint.List.IResponse,
    Api.Core.ProductEnhancementTierPricePoint.List.IHeaders
  >({
    method: HttpMethod.get,
    url: '/api/ProductManagement/ProductEnhancementTierPricePoint',
    body,
    headers: getDefaultHeaders(),
  });
}
export async function productEnhancementTierPricePointSaveApi(
  body: Api.Core.ProductEnhancementTierPricePoint.Save.IRequest
): Promise<Api.Res<Api.Core.ProductEnhancementTierPricePoint.Save.IResponse>> {
  const serverResponse = await executeServerApi<
    Api.Core.ProductEnhancementTierPricePoint.Save.IRequest,
    Api.Core.ProductEnhancementTierPricePoint.Save.IResponse,
    Api.Core.ProductEnhancementTierPricePoint.Save.IHeaders
  >({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url: '/api/ProductManagement/ProductEnhancementTierPricePoint',
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function productEnhancementTierPricePointDeleteApi(
  body: Api.Core.ProductEnhancementTierPricePoint.Delete.IRequest
): Promise<Api.Res<Api.Core.ProductEnhancementTierPricePoint.Delete.IResponse>> {
  const serverResponse = await executeServerApi<
    Api.Core.ProductEnhancementTierPricePoint.Delete.IRequest,
    Api.Core.ProductEnhancementTierPricePoint.Delete.IResponse,
    Api.Core.ProductEnhancementTierPricePoint.Delete.IHeaders
  >({
    method: HttpMethod.delete,
    url: createPathFromRoute('/api/ProductManagement/ProductEnhancementTierPricePoint/:id', body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}

export default class ProductEnhancementTierPricePoint
  extends Model<Model.IProductEnhancementTierPricePoint>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductEnhancementTierPricePoint>
{
  id: number;
  termInMonths: number;
  priceCAD: number;
  productEnhancementId: number;
  tierId: number;
  pricingDistributions?: Utils.PricingDistribution;
  productProvinceGroupId?: number;

  constructor(
    data: Partial<Model.IProductEnhancementTierPricePoint> | Utils.FormData<Model.IProductEnhancementTierPricePoint>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    const { lang } = getLocales();
    return {
      id: this.id,
      title: `${this.termInMonths}${lang.month}`,
      info: `${this.priceCAD}$`,
    };
  }
  static async list(body?: Api.Core.ProductEnhancementTierPricePoint.List.IRequest) {
    const { payload, ...rest } = await productEnhancementTierPricePointListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ProductEnhancementTierPricePoint(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await productEnhancementTierPricePointSaveApi(this);
  }
  async delete() {
    return await productEnhancementTierPricePointDeleteApi({ id: this.id });
  }
}
